(function () {
    'use strict';

    angular
        .module('app')
        .controller('TicketPriceEstimatorController', TicketPriceEstimatorController);

        TicketPriceEstimatorController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies'];

    function TicketPriceEstimatorController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies) {
        $rootScope.dark_text_header = true;
        var vm = this;
        
        // Values
        vm.ticketPrice = 0;
        vm.totalPrice = 0;

        vm.detailArtist = 0;
        vm.detailRoyalties = 0;
        vm.detailLowfi = 0;
        vm.detailHost = 0; 

        vm.apiPriceList = [];        

        // Methods
        vm.$onInit = init;
        vm.close = close;
        vm.increment = increment;
        vm.decrement = decrement;
        vm.calcTicketPrice = calcTicketPrice;

        function init() {
            apiGetPriceList()
            if($stateParams.main_genre) {
                document.getElementById('input-artist-category').value = $stateParams.main_genre;
            }
            
        }

        function increment(){
            let ticketCountElement = document.getElementById('input-ticket-count')
            ticketCountElement.value = parseInt(ticketCountElement.value)+1 
        }

        function decrement(){
            let ticketCountElement = document.getElementById('input-ticket-count')
            let number = parseInt(ticketCountElement.value)
            if (number > 12){
                ticketCountElement.value = number-1 
            }
            else{
                ticketCountElement.value = 12
            }
        }

        /*
        Regnestykket er procentdel per aktør af samlet indtægt:


        Samlet indtægt = billetpris x antal pladser 

        Artist  (57 x samlet indtægt) / 100
        Royalties  (8 x samlet indtægt) / 100
        Low-Fi  (20 x samlet indtægt) / 100
        Host  (15 x samlet indtægt) / 100
        */


        function calcTicketPrice(){
            let categoryElement = document.getElementById('input-artist-category')
            let ticketCountElement = document.getElementById('input-ticket-count')
            let categoryInt = parseInt(categoryElement.value)
            let ticketCountInt = parseInt(ticketCountElement.value)

            // Guards: Check before continuing
            // Check api has fetched the pricelist and user have not manually written 0 in the textbox. You can not devide by zero.
            if( vm.apiPriceList.length === 0 || ticketCountInt === 0 ){
                // Do nothing
               return null
            }

            let array = vm.apiPriceList
            let priceObject = array.find(obj =>  obj["filter_value_id"] === categoryInt);

            let filter_value_name = priceObject["filter_value_name"]  || 0
            let genre_ticket_price_currency = priceObject["genre_ticket_price_currency"]  || 0
            let genre_ticket_price_lower = priceObject["genre_ticket_price_lower"]  || 0
            let genre_ticket_price_median = priceObject["genre_ticket_price_median"]  || 0
            let genre_ticket_price_upper = priceObject["genre_ticket_price_upper"] || 0

            // Todo: Jeg bruger Median til at udregne det nu... hvad skal der bruges?
            let ticketPrice = genre_ticket_price_median
            vm.ticketPrice = Math.round(ticketPrice)

            // Samlet indtægt
            let totalIncome = ticketCountInt * ticketPrice
            vm.totalPrice = Math.round(totalIncome);

            // Artist (57 x samlet indtægt) / 100
            vm.detailArtist = Math.round( (57 * totalIncome) / 100);
            
            // Royalties (10 x samlet indtægt) / 100
            vm.detailRoyalties = Math.round((10 * totalIncome) / 100);
            
            // Lowfi (20 x samlet indtægt) / 100
            vm.detailLowfi = Math.round((20 * totalIncome) / 100);

            // Host (15 x samlet indtægt) / 100
            vm.detailHost = Math.round((15 * totalIncome) / 100); 

        }

        function apiGetPriceList() {
            return $http.get('/app/api/genre_price_ranges/')
                .then(function (response) {
                    vm.apiPriceList = response.data;

                    // vm.giftCardAmount = response.data.amount / 100;
                    // vm.giftCardCode = response.data.code;
                    // vm.giftCardExpirationDate = response.data.expiration_date;
                    // vm.giftCardCurrency = response.data.currency;
                });
        }

        function close() {
            // if ($rootScope.previousState && typeof $rootScope.previousState.name == 'string') {
            //     // if the previous state has been set in $transitions hook
            //     return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            // } else {
            //     return $state.go('frontpage');
            // }
        }

    }
})();